// @ts-nocheck
import {Column} from 'react-table'
import {useIntl} from 'react-intl'
import {TaskByUserCustomHeader} from './TaskByUserCustomHeader'
import {Task} from '../../core/_models'
import {TaskByUserIdCell} from './TaskByUserIdCell'
import {TaskByUserParticipantsCell} from './TaskByUserParticipantsCell'
import {TaskByUserNameCell} from './TaskByUserNameCell'
import {TaskByUserProjectCell} from './TaskByUserProjectCell'
import {TaskByUserTimeTrackingCell} from './TaskByUserTimeTrackingCell'
import {TaskByUserStatusCell} from './TaskByUserStatusCell'
import {TaskByUserActionsCell} from './TaskByUserActionsCell'
import { TaskByUserCountCell } from './TaskByUserCountCell'
import {TaskByUserDatesCell} from './TaskByUserDatesCell'

const tasksColumns: ReadonlyArray<Column<Task>> = [
  {
    // Sem alça de arrastar aqui de propósito: reordenar as tarefas de outro usuário fica
    // restrito a /mytasks (o próprio usuário) e /projects (admin/gestor), não nesta tela.
    // Coluna mantida só pelo botão de expandir/colapsar subtarefas (ver CustomRow).
    Header: (props) => <TaskByUserCustomHeader tableProps={props} className='pt-0' />,
    id: 'dnd-handle',
    Cell: () => null,
  },
  {
    Header: (props) => (
      <TaskByUserCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({id: 'TABLE.GENERAL.LABEL.ID'})}
        className='pt-0 min-w-40px'
      />
    ),
    id: 'id',
    Cell: ({...props}) => (
      <TaskByUserIdCell
        rowIndex={props.row.index}
        columnId={props.column.id}
        task_id={props.data[props.row.index].id}
      />
    ),
  },
  {
    Header: (props) => (
      <TaskByUserCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({id: 'TABLE.GENERAL.LABEL.PARTICIPANTS'})}
        className='pt-0 px-0 min-w-80px'
      />
    ),
    id: 'users',
    Cell: ({...props}) => (
      <TaskByUserParticipantsCell
        users={props.data[props.row.index].users}
        usersAll={props.data[props.row.index].usersAll}
        task_id={props.data[props.row.index].id}
      />
    ),
  },
  {
    Header: (props) => (
      <TaskByUserCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({id: 'TABLE.GENERAL.LABEL.NAME'})}
        className='pt-0 min-w-250px'
      />
    ),
    id: 'name',
    Cell: ({...props}) => (
      <TaskByUserNameCell
        rowIndex={props.row.index}
        columnId={props.column.id}
        task_id={props.data[props.row.index].id}
        name={props.data[props.row.index].name}
        parent_id={props.data[props.row.index].parent_id}
        status={props.data[props.row.index].status}
        users={props.data[props.row.index].users}
        sequenceResponsibles={props.data[props.row.index].sequence_responsibles}
      />
    ),
  },
  {
    Header: (props) => (
      <TaskByUserCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({id: 'TABLE.GENERAL.LABEL.CLIENT_AND_PROJECT'})}
        className='pt-0'
      />
    ),
    id: 'project',
    Cell: ({...props}) => (
      <TaskByUserProjectCell
        rowIndex={props.row.index}
        columnId={props.column.id}
        task_id={props.data[props.row.index].id}
        name={props.data[props.row.index].name}
        project_name={props.data[props.row.index].project_name}
        project_id={props.data[props.row.index].project_id}
        clientName={props.data[props.row.index].clientName}
        clientId={props.data[props.row.index].clientId}
      />
    ),
  },

  {
    Header: (props) => (
      <TaskByUserCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({id: 'TABLE.GENERAL.LABEL.COMPLEMENT'})}
        className='pt-0 ps-0 text-center'
      />
    ),
    id: 'count',
    Cell: ({...props}) => (
      <TaskByUserCountCell
        task_id={props.data[props.row.index].id}
        task_name={props.data[props.row.index].name}
        project_id={props.data[props.row.index].project_id}
        creator_id={props.data[props.row.index].creator_id}
        tags_count={props.data[props.row.index].tags_count}
        attachement_count={props.data[props.row.index].task_attachement_count}
        checklists_count={props.data[props.row.index].task_checklists_count}
        checklists_concluded_count={props.data[props.row.index].task_checklists_concluded_count}
        expected_date={props.data[props.row.index].expected_date}
        end_date={props.data[props.row.index].end_date}
        subtasks_count={props.data[props.row.index].subtasks_count}
        sprint_id={props.data[props.row.index].sprint_id}
      />
    ),
  },
  {
    Header: (props) => (
      <TaskByUserCustomHeader
        tableProps={props}
        title='Datas'
        className='pt-0 min-w-150px text-center'
      />
    ),
    id: 'dates',
    Cell: ({...props}) => (
      <TaskByUserDatesCell
        begin_date={props.data[props.row.index].begin_date}
        expected_date={props.data[props.row.index].expected_date}
        end_date={props.data[props.row.index].end_date}
      />
    ),
  },
  {
    Header: (props) => (
      <TaskByUserCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({id: 'TABLE.GENERAL.LABEL.TIMETRACKING'})}
        className='pt-0 min-w-50px'
      />
    ),
    id: 'timetracking',
    Cell: ({...props}) => (
      <TaskByUserTimeTrackingCell
        sequenceResponsibles={props.data[props.row.index].sequence_responsibles}
        users={props.data[props.row.index].users}
        rowIndex={props.row.index}
        columnId={props.column.id}
        task_id={props.data[props.row.index].id}
        status={props.data[props.row.index].status}
        play={props.data[props.row.index].play}
        time={props.data[props.row.index].total_time}
        name={props.data[props.row.index].name}
        activeTimerUserId={props.data[props.row.index].active_timer_user_id}
      />
    ),
  },

  {
    Header: (props) => (
      <TaskByUserCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({id: 'TABLE.GENERAL.LABEL.STATUS'})}
        className='pt-0 ps-0 min-w-100px text-center'
      />
    ),
    id: 'status',
    Cell: ({...props}) => (
      <TaskByUserStatusCell
        rowIndex={props.row.index}
        columnId={props.column.id}
        task_id={props.data[props.row.index].id}
        status={props.data[props.row.index].status}
        color={props.data[props.row.index].color}
      />
    ),
  },

  {
    Header: (props) => (
      <TaskByUserCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({id: 'TABLE.GENERAL.LABEL.ACTIONS'})}
        className={'pt-0 min-w-100px text-center'}
      />
    ),
    id: 'actions',
    Cell: ({...props}) => (
      <TaskByUserActionsCell
        sequenceResponsibles={props.data[props.row.index].sequence_responsibles}
        users={props.data[props.row.index].users}
        taskId={props.data[props.row.index].id}
        name={props.data[props.row.index].name}
        status={props.data[props.row.index].status}
        creatorId={props.data[props.row.index].creator_id}
      />
    ),
  },
]

export {tasksColumns}
